class ParallaxEvent {

	// commands

	get ENABLE() { return 'enable'; }
	get DISABLE() { return 'disable'; }
	get RENDER() { return 'render'; }

}

export default new ParallaxEvent();
